import { combineReducers } from 'redux';

import { loadDataReducer } from 'app/utils/redux/reducer-utils';
import { UPDATE_LICENSE_STARTED, UPDATE_LICENSE } from 'store/actions/admin/licenseActions';

export default combineReducers({
    update: loadDataReducer(UPDATE_LICENSE_STARTED, UPDATE_LICENSE),
});
